import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogClose } from "@/components/ui/dialog";
import { X } from "lucide-react";
import CostCalculator from "@/components/marketing/CostCalculator";

export { InfoHint } from "@/components/marketing/CostCalculator";

export default function CostCalculatorModal({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl max-h-[92vh] overflow-y-auto z-[200] p-0 [&>button.absolute]:hidden" data-testid="cost-calculator-modal">
        <div className="sticky top-0 z-30 bg-white/95 backdrop-blur border-b border-[#E8ECF2] px-5 md:px-6 py-3 flex items-center justify-between gap-3">
          <DialogHeader className="space-y-0">
            <DialogTitle className="text-xs uppercase tracking-[0.2em] text-[#2C6BAC] font-semibold">Off-focus calculator</DialogTitle>
            <DialogDescription className="sr-only">Calculate the cost of interruptions and the value WYLO returns</DialogDescription>
          </DialogHeader>
          <DialogClose
            aria-label="Close"
            data-testid="calc-close"
            className="flex-shrink-0 h-10 w-10 rounded-full bg-[#F8F9FC] border border-[#E8ECF2] text-[#1A1A2E] hover:bg-[#E8ECF2] flex items-center justify-center transition-colors focus:outline-none focus:ring-2 focus:ring-[#2C6BAC]"
          >
            <X size={18} />
          </DialogClose>
        </div>
        <div className="px-4 md:px-6 pb-6 pt-4">
          <CostCalculator />
        </div>
      </DialogContent>
    </Dialog>
  );
}
